import { Typography, TypographyProps } from "@mui/material";
import React from "react";

export const EllipsisTypography = (props: TypographyProps) => (
    <Typography
        textOverflow="ellipsis"
        overflow="hidden"
        whiteSpace="nowrap"
        {...props}
    >
        {props.children}
    </Typography>
);
